import { Table, Button, Pagination } from "react-bootstrap";
import { RiMore2Fill, RiMapPinLine } from "react-icons/ri";
import { useState } from "react";
import CustomPagination from "../common/CustomPagination";
import moment from "moment";

export default function EntryTable({ entryExitData, pagination, pageHandler }) {

  const formatTime = (time, timezone = "UTC") => {
    if (!time) return "-";
    let dateValue = time;
    if (typeof time === "object") { dateValue = time?.$date; }
    if (!dateValue) return "-";
    return moment(dateValue).tz(timezone).format("MMMM DD, hh:mm A");
  };

  return (
    <div className="ee-table">

      {/* TABLE */}
      <div className="table-responsive">
        <Table hover className="ee-custom-table align-middle">

          <thead>
            <tr>
              <th className="text-nowrap">Date & Time</th>
              <th>Activity</th>
              <th>Driver</th>
              <th>Truck</th>
              <th>Yard</th>
              {/* <th>Gate</th> */}
              <th className="text-nowrap">Gate Code</th>
              <th>Duration</th>
            </tr>
          </thead>

          <tbody>
            {entryExitData.length > 0 ? (
              entryExitData.map((item, i) => (
                <tr key={i}>

                  <td data-label="Date">
                    {formatTime(item?.eventTime, item?.detectedLocation?.timezone)}
                  </td>

                  <td data-label="Activity">
                    <span className={`status text-nowrap ${item?.activity.toLowerCase()}`}>
                      ● {item?.activity}
                    </span>
                  </td>

                  <td data-label="Driver">
                    <div className="driver-cell">
                      <img
                        src={item?.driver?.profileImage || "assets/images/placeholder.png"}
                        alt="driver"
                        className="avatar"
                      />
                      <div>
                        <strong>{item?.driver?.userName}</strong>
                        <p className="mb-0">{item?.driver?.phoneNumber}</p>
                      </div>
                    </div>
                  </td>

                  <td data-label="Truck">
                    <strong className="text-nowrap">{item?.vehicle?.vehicleName}</strong>
                    <p>{item?.vehicle?.plate}</p>
                  </td>

                  <td data-label="Yard" className=" text-nowrap">
                    <RiMapPinLine /> {item?.detectedLocation?.locationName || "-"}
                  </td>

                  {/* <td data-label="Gate">{item.gate}</td> */}
                  <td data-label="Code" className="fw-semibold">{item?.gateCode || ""}</td>
                  <td data-label="Duration">
                    {item?.durationMinutes
                      ? `${Math.floor(moment.duration(item.durationMinutes, "minutes").asHours())}h ${moment.duration(item.durationMinutes, "minutes").minutes()}m`
                      : ""}
                  </td>

                  {/* <td data-label="Action" className="d-flex gap-2">
                  <Button size="sm">View</Button>
                  <Button variant="light">
                    <RiMore2Fill />
                  </Button>
                </td> */}

                </tr>
              ))) : (
              <tr>
                <td colSpan="8" className="text-center mx-auto py-4">
                  No activity found.
                </td>
              </tr>
            )}
          </tbody>

        </Table>
      </div>

      {/* PAGINATION */}
      <CustomPagination
        pagination={pagination}
        pageHandler={pageHandler}
      />

    </div>
  );
}